import { Component, OnInit } from "@angular/core";
import { User } from "./../../models/user";
import { VproService } from "./../../service/vpro/vpro.service";

import Swal from "sweetalert2";
import { Utils } from "src/app/common/utils";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.css"]
})
export class RegisterComponent {
  user = new User();
  usereid: string;
  editUser: string;
  dataValue2: any;
  dataValue: any;
  innerHtml: string = "";
  emailpat = Utils.emailpat_withNoPlus;
  // @SessionStorage() sessionValue = `I must be coming from Planet AWS you know ! `;

  constructor(private userService: VproService, private router: Router, private spinner: NgxSpinnerService,) { }

  public save(): void {

    this.user.first_name = this.user.first_name.charAt(0).toUpperCase() + this.user.first_name.slice(1).toLowerCase();
    this.user.last_name = this.user.last_name.charAt(0).toUpperCase() + this.user.last_name.slice(1).toLowerCase();
    if (this.user && this.user.email_id) {
      this.user.email_id = this.user.email_id.toLowerCase();
    }
    this.spinner.show();
    this.userService.addUser(this.user).subscribe(res => {
      // Set localstorage items
      localStorage.setItem("usethis", this.user.email_id);
      sessionStorage.setItem("fname", this.user.first_name);
      sessionStorage.setItem("lname", this.user.last_name);
      // Shoot a mail to user
      this.userService.mailUser(this.user).subscribe(res => {
        this.spinner.hide();
        // SweetAlert
        Swal.fire({
          allowOutsideClick: false,
          position: "top",
          type: "success",
          title:
            "User has been registered, check your email for account activation ",
          showConfirmButton: false,
          timer: 2100
        });
        this.router.navigate(["/info-basic"]);
      }, error => {
        ;
        this.spinner.hide();
        // SweetAlert
        Swal.fire({
          allowOutsideClick: false,
          position: "top",
          type: "error",
          title:
            "Something went wrong. Please try again later.",
          showConfirmButton: false,
          timer: 2100
        });
      });
    }, error => {
      this.spinner.hide();
      // SweetAlert
      Swal.fire({
        allowOutsideClick: false,
        position: "top",
        type: "error",
        title:
          "Something went wrong. Please try again later.",
        showConfirmButton: false,
        timer: 2100
      });
    });
  }

  checkEid() {
    try {
      this.spinner.show();
      this.userService.authUser2(this.user).subscribe(
        data => {
          this.spinner.hide();
          this.dataValue2 = data["utype"];

          if (this.dataValue2 !== 8) {
            this.innerHtml = `<div class="alert alert-danger"> This email-id is already registered with us, please use another !</div>`;

            document.getElementById("email_id").focus();
          } else {
            this.innerHtml = "";

            document.getElementById("email_id").blur();
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (excep) {
      this.spinner.hide();
    }
  }
}
